'use client';

import { SmallCard } from '@components/card';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ReasonCard } from '../types';

interface SliderProps {
  cards: ReasonCard[];
  cardHeight?: number;
}

export const Slider = ({ cards, cardHeight = 236 }: SliderProps) => (
  <Swiper spaceBetween={12} slidesPerView="auto" className="!px-5 !py-2">
    {cards.map(({ imageData, id, description, href, alt }) => {
      if (!imageData) {
        return null;
      }

      return (
        <SwiperSlide key={id}>
          <SmallCard
            descriptionTypographVariant="text-base"
            descriptionId={id}
            imageData={imageData}
            description={description}
            href={href}
            alt={alt}
            cardHeight={cardHeight}
          />
        </SwiperSlide>
      );
    })}
  </Swiper>
);
